import React, { useRef } from "react";
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import FormikContainer from "../../components/Formik/FormikContainer";
import { ErrorMessage, Form } from "formik";
import FieldContainer from "../../components/Formik/FieldContainer";
import DImage from "../../components/DImage";
import DButton from "../../components/DButton";
import ErrorMsg from "../../components/Formik/Fields/ErrorMsg";
import * as Yup from "yup";
import { imageFormat, imageSize } from "../../utils/functions";
import { Spinner } from "@chakra-ui/react";
import adsServices from "../../services/ads";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";

const validationSchema = Yup.object().shape({
    adsImage: Yup.mixed()
        .test("image-format", "يرجى تحميل صورة", value => {
            return value
                ? imageFormat.includes(value.type.split("/")[1])
                : false;
        })
        .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", value => {
            return value ? imageSize >= value.size : false;
        }),
});
const AddAds = ({ title }) => {
    const fileRef = useRef();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const setImageHandler = value => {
        if (value?.type) {
            return URL.createObjectURL(value);
        }
        return value;
    };
    const deleteImageHandler = setFieldValue => {
        fileRef.current.value = "";
        setFieldValue("adsImage", "");
    };
    const onSubmit = (values, { setSubmitting }) => {
        const formData = new FormData();
        formData.append("img", values.adsImage);

        adsServices
            .addAds(formData)
            .then(res => {
                toast.success("تم الاضافة بنجاح");
                queryClient.refetchQueries("getAllAds");
                setTimeout(() => {
                    navigate("/ads");
                }, 1500);
            })
            .catch(err => {
                toast.error("فشلت الاضافة");
                setSubmitting(false);
                console.log(err);
            });
    };
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard>
                <FormikContainer
                    initialValues={{
                        adsImage: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, setFieldValue, isSubmitting }) => {
                        return (
                            <Form>
                                <div className="mb-10 flex flex-col items-center mx-auto text-center">
                                    <label className="mb-2" htmlFor="adsImage">
                                        صورة الاعلان:
                                    </label>
                                    <FieldContainer
                                        fileRef={fileRef}
                                        name="adsImage"
                                        type="file"
                                        accept="image/*"
                                        id="adsImage"
                                        hidden
                                    />
                                    <div className="w-full">
                                        {values.adsImage && (
                                            <>
                                                <div className="mb-4 relative lg:w-2/4 h-[250px] border border-light-color rounded-sm mx-auto">
                                                    <DImage
                                                        className="w-full h-full object-fill"
                                                        src={setImageHandler(
                                                            values.adsImage
                                                        )}
                                                        alt={"adsImage"}
                                                        load={true}
                                                    />
                                                </div>
                                                <DButton
                                                    onClick={() =>
                                                        deleteImageHandler(
                                                            setFieldValue
                                                        )
                                                    }
                                                    className="text-white"
                                                    bgColor="danger"
                                                >
                                                    حذف الصورة
                                                </DButton>
                                            </>
                                        )}
                                        <DButton
                                            bgColor="secondry"
                                            onClick={() =>
                                                fileRef.current?.click()
                                            }
                                        >
                                            تحميل صورة
                                        </DButton>
                                        <div className="block">
                                            <ErrorMessage
                                                name="adsImage"
                                                component={ErrorMsg}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <DButton
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={
                                        "flex items-center justify-center mx-auto min-w-[150px] text-white"
                                    }
                                >
                                    {isSubmitting ? <Spinner /> : "اضافة اعلان"}
                                </DButton>
                            </Form>
                        );
                    }}
                </FormikContainer>
            </DCard>
        </div>
    );
};

export default AddAds;
